module.exports = __webpack_public_path__ + "static/b_tt-8cc6f06731276942809dbf17e421180a.jpeg";